import { Link, Outlet } from 'react-router-dom';
import { Button } from './ui/button.tsx';
import { useAuthSession, useSignOut } from '../features/auth/useAuth.ts';
import { usePageviewTracking } from '../lib/analytics.ts';

/**
 * Top-level frame around every route. Wires the GA4 page-view hook,
 * renders the header, and delegates the body to the matched route via
 * <Outlet/>.
 */
export function Layout() {
  usePageviewTracking();

  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

function Header() {
  const { data: session, isLoading } = useAuthSession();
  const signOut = useSignOut();

  return (
    <header className="border-b border-neutral-800">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4">
        <Link to="/" className="text-lg font-semibold tracking-tight hover:text-neutral-300">
          uttzs
        </Link>
        <nav className="flex items-center gap-2">
          {!isLoading && session && (
            <>
              <Button asChild variant="ghost" size="sm">
                <Link to="/dev">Dashboard</Link>
              </Button>
              <Button asChild variant="ghost" size="sm">
                <Link to="/me">Profile</Link>
              </Button>
              <Button
                variant="secondary"
                size="sm"
                onClick={() => signOut.mutate()}
                disabled={signOut.isPending}
              >
                Sign out
              </Button>
            </>
          )}
          {!isLoading && !session && (
            <>
              <Button asChild variant="ghost" size="sm">
                <Link to="/signin">Sign in</Link>
              </Button>
              <Button asChild size="sm">
                <Link to="/signup">Sign up</Link>
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}

function Footer() {
  return (
    <footer className="border-t border-neutral-800 py-6 text-center text-xs text-neutral-500">
      <p>uttzs.kohuehara.xyz · v2.0</p>
    </footer>
  );
}
